import { IconAlertCircle, IconPhoneFilled } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { NEW_IwLinkButton } from '@iwRouter/NEW_IwLinkButton';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './TruelayerConfirmation.module.css';
import messages from '../../modals/manualPaymentModal/ManualPaymentModal.messages';
import { TRUELAYER_REDIRECT_BACK_TO_PAYMENT_CONFIRMATION } from '../EarlyRepayment.actions';

const phoneNumber = '020 3397 3375';

type PaymentFailedProps = {
    accountId: string;
    amount: number;
};

function mapDispatchToProps(dispatch: Dispatch, ownProps: any) {
    return {
        redirectBackToPaymentConfirmation: () =>
            dispatch({
                type: TRUELAYER_REDIRECT_BACK_TO_PAYMENT_CONFIRMATION,
                payload: {
                    accountId: ownProps.accountId,
                    amount: ownProps.amount
                }
            })
    };
}

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const _PaymentFailed = ({
    redirectBackToPaymentConfirmation
}: PaymentFailedProps & PropsFromRedux) => (
    <>
        <div className={styles.confirmationContainer}>
            <IconAlertCircle className={styles.alertIcon} />
            <div
                className={styles.primaryContent}
                data-testid="message-container"
            >
                <p>Sorry, we couldn't process your payment.</p>
                <p>Please try again or give us a call</p>
                <div className="flex justify-center">
                    <a href={`tel:${phoneNumber}`}>
                        <div className="flex items-center">
                            <IconPhoneFilled className="mr-s size-2xl" />
                            <span className="font-bold">{phoneNumber}</span>
                        </div>
                    </a>
                </div>
            </div>
            <div className="mt-xl flex flex-col space-y-m p-xl min-sm:mt-3xl min-sm:flex-row min-sm:justify-center min-sm:space-x-m min-sm:space-y-0">
                <NEW_IwLinkButton
                    to={{
                        pathname: '/'
                    }}
                    variant="secondary"
                    className="min-sm:w-[200px]"
                >
                    <FormattedMessage {...messages.returnToDashboard} />
                </NEW_IwLinkButton>
                <Button
                    onClick={redirectBackToPaymentConfirmation}
                    variant="primary"
                    className="h-3xl min-sm:w-[200px]"
                >
                    Try again
                </Button>
            </div>
        </div>
    </>
);

export const PaymentFailed = connect(
    () => ({}),
    mapDispatchToProps
)(_PaymentFailed);
